import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Button from '../../../../button';
import Modalheader from '../../../components/header';
import ModalBody from '../../../components/body';
import ModalFooter from '../../../components/footer';
import useModal from '../../../useModal';
import UseContext from '../../../../../hooks/useContext';
import ApiDatabase from 'server';

const ModalMissionResume = () => {
  const { toggle } = useModal();
  const { objID, setModalDataReturn, updateMissionStatusLocal } = UseContext();
  const [isLoading, setIsLoading] = useState(false);
  const [missionData, setMissionData] = useState(null);
  const token = localStorage.getItem('xsrfToken');

  useEffect(() => {
    if (token && objID) {
      ApiDatabase.getMissionDetailsById(
        { token, idMission: objID },
        (data) => setMissionData(data),
        (err) => console.error(err),
        { skipCache: true }
      );
    }
  }, [token, objID]);

  const handleSubmit = () => {
    if (!token || !objID) return;
    setIsLoading(true);
    ApiDatabase.updateMissionStatus(
      { token, idMission: objID, newStatus: 'online' },
      () => {
        updateMissionStatusLocal(objID, { status: 'online', reason: null });
        setModalDataReturn('mission_status_updated');
        toast.success('La mission est de nouveau en ligne');
        setIsLoading(false);
        toggle();
      },
      (err) => {
        toast.error('Erreur lors de la mise en ligne : ' + err);
        setIsLoading(false);
      }
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Mettre la mission en ligne
      </Modalheader>
      <ModalBody>
        {!missionData ? (
          <div className="flex flex-col gap-3 animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-4 bg-gray-200 rounded w-3/4" />
          </div>
        ) : (
          <div className="flex flex-col gap-3">
            <p>
              Êtes-vous sûr de vouloir mettre en ligne la mission{' '}
              <span className="font-black">
                {missionData.title} n°{missionData.id_mission}
              </span>
              . La mission sera de nouveau visible par les candidats.
            </p>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button size="LG" color="SECONDARY" onClick={toggle}>
          Annuler
        </Button>
        {isLoading ? (
          <Button size="LG" color="DISABLED">
            Confirmation ...
          </Button>
        ) : (
          <Button size="LG" color="PRIMARY" onClick={handleSubmit} disabled={!missionData}>
            Confirmer
          </Button>
        )}
      </ModalFooter>
    </>
  );
};

export default ModalMissionResume;
